export default function WorkProcessTwo(){
    return(
        <>
        <section className="work-process-area process-bg2 pt-160 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
			<div className="container">
				<div className="row text-center">
					<div className="section-ttile mb-60">
						<p className="white-title">Work Process</p>
						<h2 className="sect-title text-white">Solutions to Company & Individuals</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-3 col-md-6">
						<div className="process-box text-center mb-30">
							<div className="icon">
								<img src="assets/img/icon/p-2a.png" alt="Icon" />
							</div>
							<p>Step 01</p>
							<h5 className="fs-20 text-white">Discuss about project</h5>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="process-box text-center mb-30">
							<div className="icon ic-2">
								<img src="assets/img/icon/p-2b.png" alt="Icon" />
							</div>
							<p>Step 02</p>
							<h5 className="fs-20 text-white">Discuss about project</h5>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="process-box text-center mb-30">
							<div className="icon">
								<img src="assets/img/icon/p-2c.png" alt="Icon" />
							</div>
							<p>Step 03</p>
							<h5 className="fs-20 text-white">Discuss about project</h5>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="process-box text-center mb-30">
							<div className="icon ic-4">
								<img src="assets/img/icon/p-2d.png" alt="Icon" />
							</div>
							<p>Step 04</p>
							<h5 className="fs-20 text-white">Discuss about project</h5>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}